module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Súkromie",
	"footer.privacy.url": "https://www.grohe.sk/sk_sk/spolocnost/privacy.html",
	"footer.disclaimer.text": "Vyhlásenie",
	"footer.disclaimer.url": "https://www.grohe.sk/sk_sk/spolocnost/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Konfigurátor vodných systémov GROHE",
	"homepage.introtext": "Jednoducho odpovedzte na pár otázok nižšie a získajte takú konfiguráciu vodného systému GROHE, aká bude dokonale vyhovovať vašim požiadavkám.",
	"homepage.buttonStart": "Spustiť",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404: stránka sa nenašla",
	"404.link.goBack": "Prejsť späť na domovskú stránku",
	"configurator.button.seeResults": "Zobraziť výsledky",
	"question1.question": "Máte v kuchyni prípojku studenej a teplej vody?",
	"question1.option1.text": "Áno, v kuchyni mám prípojku studenej aj teplej vody",
	"question1.option2.text": "V kuchyni mám iba prípojku studenej vody",
	"question2.question": "Aký typ vody od vodného systému očakávate?",
	"question2.option1.text": "vriacu vodu na prípravu pokrmov a horúcich nápojov",
	"question2.option2.text": "Vychladenú, perlivú vodu na pitie",
	"question2.option3.text": "Vychladenú a perlivú vodu, ale taktiež vodu vriacu",
	"question3.question": "Chcete si ponechať svoju súčasnú drezovú batériu?",
	"question3.option1.text": "Chcem si ju ponechať",
	"question3.option2.text": "Chcem si kúpiť nový model",
	"question4.question": "Aká by mala byť vaša hlavná drezová batéria?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Aký tvar výpustu preferujete?",
	"question5.option1.text": "Výpust v tvare písmena L",
	"question5.option2.text": "Výpust v tvare písmena U",
	"question5.option3.text": "Výpust v tvare písmena C",
	"question6.question": "Aká povrchová úprava sa vám páči najviac?",
	"question6.option1.text": "Chrómová",
	"question6.option2.text": "SuperSteel",
	"question7.question": "Aký veľký bojler potrebujete?",
	"question7.option1.text": "Veľkosť M (3 litre)",
	"question7.option2.text": "Veľkosť L (5,5 litra)",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledok} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Na správnu inštaláciu budete potrebovať taktiež:",
	"results.newConfiguration.title": "Chcete spustiť konfiguráciu nového vodného systému od začiatku?",
	"results.newConfiguration.buttonText": "Spustiť konfiguráciu nového systému",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informácie o produkte",
	"results.product.button.dealerLocator": "Nájsť showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informácie o produkte",
	"results.product.dealer": "Nájsť showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.sk_sk.json
// module id = 795
// module chunks = 0